<template>
  <v-app align="left">
        <v-card class="ma-2 pa-4" align="left">
            <v-row>
                <v-col cols="10">
                    <div class="text-h5">Your queue detail</div>
                    <div class="text-h6" style="color: gray;">รายละเอียดคิวของคุณ</div>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="ma-2 pa-4" align="left">

            <v-row>
                <v-col cols="5" align="left">
                    <div class="text-subtitle-1">Station</div>
                    <div class="text-subtitle-2" style="color: gray;">จุดบริการ</div>
                </v-col>
                <v-col cols="7">
                    <div class="text-subtitle-1">{{ station_name }}</div>
                    <div class="text-subtitle-2" style="color: gray;">{{ station_name_th }}</div>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="5" align="left">
                    <div class="text-subtitle-1">Group</div>
                    <div class="text-subtitle-2" style="color: gray;">กลุ่มบริการ</div>
                </v-col>
                <v-col cols="7">
                    <div class="text-h5">{{ queue_group }}</div>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="5" align="left">
                    <div class="text-subtitle-1">Queue Number</div>
                    <div class="text-subtitle-2" style="color: gray;">หมายเลขคิว</div>
                </v-col>
                <v-col cols="7">
                    <div class="text-h5">{{ queue_number }}</div>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="5" align="left">
                    <div class="text-subtitle-1">Status</div>
                    <div class="text-subtitle-2" style="color: gray;">สถานะ</div>
                </v-col>
                <v-col cols="7">
                    <div class="text-subtitle-1">{{ queue_status }}</div>
                    <div class="text-subtitle-2" style="color: gray;">{{ queue_status_th }}</div>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="5" align="left">
                    <div class="text-subtitle-1">{{ queue_status_extra1 }}</div>
                    <div class="text-subtitle-2" style="color: gray;">{{ queue_status_extra1_th }}</div>
                </v-col>
                <v-col cols="7">
                    <div class="text-subtitle-1">{{ queue_status_extra2 }}</div>
                    <div class="text-subtitle-2" style="color: gray;">{{ queue_status_extra2_th }}</div>
                </v-col>
            </v-row>
        </v-card>

         <a :href="tracking_url" class="ma-6">
                <div style="background-color: rgb(0, 185, 0); align-items: center; color: white;">
                    <v-row>
                        <v-col cols="3" align="center" class="pl-8">
                            <v-img 
                                style="max-width: 75px;"
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/1024px-LINE_logo.svg.png"
                            />
                        </v-col>     
                        <v-col cols="9" class="ml-n4"><b>
                            <div class="text-h6"> Accept LINE NOTIFICATION </div>
                            <div class="text-subtitle-1"> ติดตามคิวนี้ผ่าน LINE </div>
                        </b></v-col>
                    </v-row>
                </div>
            </a>
            
    </v-app>
</template>

<script>

import axios from 'axios';
import config from '@/../config.js'

export default {
    data () {
        return {
            "queue_id": null,
            "station_code": null,
            "queue_round": null,
            "queue_group": null,
            "queue_status_id": null,
            "queue_number": null,
            "queue_count_wait": null,
            "queue_calling_number": null,
            "queue_calling_by": null,
            "queue_datetime_created": null,
            "queue_datetime_updated": null,
            "tracking_url": null,
            "station_name": null,
            "station_name_th": null,

            "queue_status": null,
            "queue_status_th": null,
            "queue_status_extra1": null,
            "queue_status_extra1_th": null,
            "queue_status_extra2": null,
            "queue_status_extra2_th": null,
        }
    },
    mounted : function () {
        this.reload()
    },
    methods: {
        reload(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.public.queue.get_queuedetail
                ,{qrcode:this.$route.params.qrcode}
            )
            .then(response => {
                this.queue_id = response.data.queue_id
                this.station_code = response.data.station_code
                this.queue_round = response.data.queue_round
                this.queue_group = response.data.queue_group
                this.queue_status_id = response.data.queue_status_id
                this.queue_number = response.data.queue_number
                this.queue_count_wait = response.data.queue_count_wait
                this.queue_calling_number = response.data.queue_calling_number
                this.queue_calling_by = response.data.queue_calling_by
                this.queue_datetime_created = response.data.queue_datetime_created
                this.queue_datetime_updated = response.data.queue_datetime_updated
                this.tracking_url = response.data.tracking_url
                this.station_name = response.data.station_name
                this.station_name_th = response.data.station_name_th

                console.log(this.tracking_url)

                if(this.queue_status_id == 1){
                    this.queue_status = "Waiting"
                    this.queue_status_th = "รอเรียกคิว"
                    this.queue_status_extra1 = "Queue(s) ahead"
                    this.queue_status_extra1_th = "รออีก"
                    this.queue_status_extra2 = this.queue_count_wait + (this.queue_calling_number != null ? " Queue (Calling " + this.queue_calling_number + ')' : "")
                    this.queue_status_extra2_th = this.queue_count_wait + (this.queue_calling_number != null ? " คิว (กำลังเรียก " + this.queue_calling_number + ')' : "")
                }else if(this.queue_status_id == 2){
                    this.queue_status = "Calling"
                    this.queue_status_th = "กำลังเรียกคิว"
                    this.queue_status_extra1 = "Please contact"
                    this.queue_status_extra1_th = "กรุณารับบริการ"
                    this.queue_status_extra2 = "Counter " + this.queue_calling_by
                    this.queue_status_extra2_th = "ที่ช่องบริการ " + this.queue_calling_by
                }else if(this.queue_status_id == 3){
                    this.queue_status = "Finished"
                    this.queue_status_th = "สิ้นสุดการให้บริการ"
                }

                this.$store.commit('finishLoading',que)
            })
        }
    }
}
</script>